import { CartItem } from '../../types/figs'
import { CheckoutLineItemInput, CustomAttribute } from '../../types/shopify-storefront-api'

export function mapPropertiesToCustomAttributes(
  properties: CartItem['properties']
): ReadonlyArray<CustomAttribute> {
  return Object.keys(properties).reduce((customAttributes, key) => {
    const value: string | undefined = properties[key]
    return value ? [...customAttributes, { key, value }] : customAttributes
  }, [] as ReadonlyArray<CustomAttribute>)
}

export function mapCartItemToCheckoutLineItemInput(
  variantGid: string,
  quantity: number,
  properties?: CartItem['properties']
): CheckoutLineItemInput {
  return {
    customAttributes: mapPropertiesToCustomAttributes(properties ?? {}),
    quantity,
    variantId: btoa(variantGid),
  }
}

export function mapFigsCartItemsToShopifyCheckoutItems(
  figsCartItems: CartItem[]
): CheckoutLineItemInput[] {
  return figsCartItems
    .map(o => {
      return mapCartItemToCheckoutLineItemInput(o.variantId, o.quantity, {
        ...o.properties,
      })
    })
    .flat()
}
